import React, { useCallback, useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";
import CentralDashboardService from "../../services/centraldashboard.service";
import "./central.css";

const VehicleStatusGraph = () => {
  const [vehicleCounts, setVehicleCounts] = useState([
    {
      depoLoc_Name: "",
      vehicle: [],
    },
  ]);
  const [vehicleList, setVehicleList] = useState([]);
  const [selectedType, setSelectedType] = useState("1");

  useEffect(() => {
    fetchVehicleTypes();
  }, []);

  const fetchVehicleTypes = () => {
    // Vehicle Types List
    CentralDashboardService.getVehicleTypes()
      .then((response) => {
        setVehicleList(response.data);
      })
      .catch((e) => console.log(e));
  };

  const fetchVehicleCounts = useCallback(() => {
    const req = {
      vechtype: selectedType,
    };
    // Main data
    CentralDashboardService.getVehicleStsCount(req)
      .then((resp) => {
        // const fd = resp.data.filter(
        //   (itm) =>
        //     itm.depoLoc_Name === "Gangtok" || itm.depoLoc_Name === "Silliguri"
        // );
        setVehicleCounts(resp.data);
      })
      .catch((e) => console.log(e));
  }, [selectedType]);

  useEffect(() => {
    fetchVehicleCounts();
  }, [fetchVehicleCounts, selectedType]);

  const chartData = {
    labels: vehicleCounts.map((item) => item.depoLoc_Name),
    datasets: [
      {
        label: "Vehicle Count",
        data: vehicleCounts.map((depot) => depot.vehiclecount),
        backgroundColor: "rgb(152, 250, 184)",
        categoryPercentage: 0.3,
        borderWidth: 1,
        borderColor: "white",
        borderRadius: {
          topLeft: 4,
          topRight: 4,
          bottomLeft: 4,
          bottomRight: 4,
        },
        borderSkipped: false,
      },
    ],
  };

  const options = {
    type: "bar",
    stacked: true,
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        display: true,
        align: "end",
        anchor: "end",
        formatter: (value, context) => {
          return value;
        },

        color: "black",
      },
      title: {
        display: false,
      },
      tooltip: {
        displayColors: true,
        yAlign: "bottom",
        backgroundColor: "rgba(254, 235, 230, 1)",
        titleColor: "black",
        bodyColor: "black",
        footerColor: "black",
        bodyFont: {
          size: 17,
          family: "Jost, sans-serif",
        },
        titleFont: {
          size: 15,
          family: "Jost, sans-serif",
        },
      },
      legend: {
        display: false,
        position: "top",
        align: "end",
        labels: {
          boxWidth: 13,
          useBorderRadius: true,
          borderRadius: "6px",
        },
      },
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          drawOnChartArea: true,
          display: false,
        },
        border: {
          display: false,
        },
        ticks: {
          font: {
            size: 13,
            weight: "bold",
            family: "Jost",
          },
        },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        grid: {
          drawOnChartArea: true,
        },
        ticks: {
          beginAtZero: true,
        },
        suggestedMin: 0,
        suggestedMax: 10,
        title: {
          display: true,
          text: "No. of Buses",
        },
      },
    },
    elements: {
      point: {
        radius: 0,
      },
    },
  };

  const handleVehicleSelect = (e) => {
    setSelectedType(e.target.value);
  };

  return (
    <>
      <div className="graph-header">
        <div className="graph-heading">Vehicle Records (Bus)</div>
        {/* <div className="graph-yearly-filter vehicle-select">
          <select onChange={handleVehicleSelect} value={selectedType}>
            <option value={""}>All</option>
          
            {Array.isArray(vehicleList) && vehicleList.length != 0
              ? vehicleList.map((item) => (
                  <option value={item.vechtype_id}>{item.vechtype}</option>
                ))
              : null}
          </select>
        </div> */}
      </div>
      <div className="">
        <Bar data={chartData} options={options} width={600} height={275} />
      </div>
    </>
  );
};

export default VehicleStatusGraph;
